const DATA_TEST_IDS = {
  noAddressView: 'profile-address__fragments_no-address-view',
} as const;

export default DATA_TEST_IDS;
